import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { selectorsFor as paginationSelectorsFor } from "store/common/pagination/selectors";
import { actionsFor as paginationActionsFor } from "store/common/pagination/actions";
import UIPagination from "components/UI/Pagination";

const PaginationSelectors = paginationSelectorsFor("worklist");
const PaginationActions = paginationActionsFor("worklist");

const mapStateToProps = state => {
  return {
    activePage: PaginationSelectors.getActivePage(state),
    startPage: PaginationSelectors.getStartPage(state),
    endPage: PaginationSelectors.getEndPage(state),
    hasNextPage: PaginationSelectors.hasNextPage(state),
    hasPrevPage: PaginationSelectors.hasPrevPage(state),
    displaying: PaginationSelectors.getDisplayingRows(state),
    displayOptions: PaginationSelectors.getDisplayOptions(state)
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      onChangePage: PaginationActions.changePage,
      onNextPage: PaginationActions.goNextPage,
      onPrevPage: PaginationActions.goPrevPage,
      onFirstPage: PaginationActions.goFirstPage,
      onLastPage: PaginationActions.goLastPage,
      onChangeDisplaying: PaginationActions.changeDisplaying
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UIPagination);
